import '../index.less';
import * as React from 'react';
import { Location } from 'history';
import Transition from 'react-transition-group/Transition';
import { RouteComponentProps } from 'react-router';
import { searchToQuery } from 'utils/router';
import element from 'utils/element';
import Show from '../Show';
import Sider from './Sider';
import { Button, Spin } from '@beehive/components';
import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import * as actions from 'modules/actions/smProjectDetail';
import { projectMove, projectDelete } from 'modules/actions/smProjectMove';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { blockDrawerClose } from 'components'
import { localPx2rem } from '@mpc/common/src/';

export const locationToProjectId = (location: Location) => {
  const query = searchToQuery(location);
  return +String(query.projectId);
};
export const locationToIsEdit = (location: Location) => {
  const query = searchToQuery(location);
  return query.type === 'edit';
};
export const locationToChangedBySider = (location: Location) => {
  const query = searchToQuery(location);
  return query.changeType === 'bySider';
};
const TRANSITION_STYLE = {
  entering: { right: localPx2rem(-1310) },
  entered: { right: 0 },
  exiting: { right: 0 },
  exited: { right: localPx2rem(-1310) },
};
export interface ProjectDetailProps extends RouteComponentProps {
  prefixCls: string;
  menuRequestMapping?: any;
  getBodyProgress?: any;
  getBottomTabElement?: any;
  baseInfoProps?: any;
  planInfoConfig?: any;
  settleInfoConfig?: any;

  account: any;
  menus: any;
  detailLoading: boolean;
  detail: any;
  showDrawerSider: boolean;
  loadingSider: boolean;
  siderData: any;
  siderSelectedKeys: any;

  loadDetail: Function;
  clearDetail: Function;
  toggleDrawerSiderShow: Function;

  projectMove: Function;
  projectDelete: Function;
  readOnly?: boolean;
  getAttachementDownloadLink?: (id: number) => string;
}

class ProjectDetailDrawer extends React.Component<ProjectDetailProps, any> {
  public static defaultProps = {
    prefixCls: 'sm-project-detail',
  };

  public static childContextTypes = {
    account: PropTypes.object,
    menuKey: PropTypes.any,
    detail: PropTypes.object,
    detailLoading: PropTypes.bool,

    loadDetail: PropTypes.func,
    projectMove: PropTypes.func,
    projectDelete: PropTypes.func,
    getAttachementDownloadLink: PropTypes.func,
  };

  public getChildContext = () => {
    const {
      account,
      detail,
      detailLoading,
      projectMove,
      projectDelete,
      menuRequestMapping,
    } = this.props;

    let menuKey = this.getMenuKey();
    if (menuRequestMapping) {
      menuKey = menuRequestMapping[menuKey] || menuKey;
    }

    return {
      account,
      menuKey,
      detail,
      detailLoading,
      loadDetail: this.loadDetail,
      projectMove,
      projectDelete,
      getAttachementDownloadLink: this.getAttachementDownloadLink,
    };
  }

  public componentDidUpdate(prevProps: ProjectDetailProps, prevState: any) {
    const prevId = locationToProjectId(prevProps.location);
    const currId = locationToProjectId(this.props.location);
    if (prevId && prevId !== currId && Number.isInteger(currId)) {
      this.loadDetail();
    }
  }

  public componentWillUnmount() {
    window.removeEventListener('click', this.handleWindowClick);
  }

  private getAttachementDownloadLink = (attachId: number) => {
    const { getAttachementDownloadLink } = this.props;

    if (getAttachementDownloadLink) {
      return getAttachementDownloadLink(attachId);
    }

    return `api/v1/attachments/${attachId}?download=attachment`;
  }

  private getMenuKey = () => {
    const { menus, location } = this.props;
    let menuKey = null;
    if (menus) {
      const keys = menus.map((item: any) => item.key);
      const nowLocation = location.pathname;
      menuKey = keys.find(
        (key: string) => !!~nowLocation.indexOf(_.camelCase(key)),
      );
    }
    return menuKey;
  }

  private loadDetail = () => {
    const { location, loadDetail } = this.props;
    const changedBySider = locationToChangedBySider(location);
    const menuKey = this.getMenuKey();
    loadDetail(locationToProjectId(location), { changedBySider }, menuKey);
  }

  private hanldeTransitionEntered = () => {
    window.addEventListener('click', this.handleWindowClick);
    this.loadDetail();
  }

  private handleTransitionExited = () => {
    window.removeEventListener('click', this.handleWindowClick);
    const { clearDetail } = this.props;
    clearDetail();
  }

  private handleWindowClick = (event: any) => {
    if (locationToProjectId(this.props.location)) {
      const whiteList = [
        '.sm-project-detail-drawer',
        '.beehive-table-body',
        '.beehive-select-trigger-popoup',
        '.beehive-modal-wrap',
        '.beehive-layout-sider-trigger',
        '.beehive-layout-sider-children .beehive-menu',
        '.mpc-header .beehive-menu',
      ];

      if (
        element.closest(event.target, '#root') &&
        !whiteList.some(
          (selector: string) => !!element.closest(event.target, selector),
        )
      ) {
        blockDrawerClose(() => {
          const { location, history } = this.props;
          history.push({
            ...location,
            search: '',
          });
        })
      }
    }
  }

  private handleSiderSelectedKeysChange = (selectedKeys: string[]) => {
    const { history, location } = this.props;
    if (!selectedKeys[0]) {
      return;
    }
    history.push({
      ...location,
      search: `projectId=${selectedKeys[0]}&changeType=bySider`,
    });
  }

  private handleSiderTriggerClick = () => {
    const { showDrawerSider, toggleDrawerSiderShow } = this.props;
    toggleDrawerSiderShow(!showDrawerSider);
  }

  public render() {
    const {
      prefixCls,
      location,
      detailLoading,
      detail = {},
      showDrawerSider,
      loadingSider,
      siderData,
      siderSelectedKeys,
      getBodyProgress,
      getBottomTabElement,
      baseInfoProps,
      planInfoConfig,
      settleInfoConfig,
      readOnly = true,
    } = this.props;

    const className = `${prefixCls}-drawer`;
    const projectId = locationToProjectId(location);
    const hasProjectId = Number.isInteger(projectId);
    const isEdit = hasProjectId && locationToIsEdit(location);
    const { has_sider = false } = detail;

    return (
      <Transition
        in={hasProjectId}
        appear
        timeout={200}
        onEntered={this.hanldeTransitionEntered}
        onExited={this.handleTransitionExited}
      >
        {(state) => {
          return (
            <div className={className} style={{ ...TRANSITION_STYLE[state] }}>
              <Spin.Global spinning={detailLoading} />
              <Show
                prefixCls={prefixCls}
                projectId={locationToProjectId(location)}
                getBodyProgress={getBodyProgress}
                getBottomTabElement={getBottomTabElement}
                baseInfoProps={baseInfoProps}
                planInfoConfig={planInfoConfig}
                settleInfoConfig={settleInfoConfig}
                readOnly={readOnly}
              />
              {has_sider && (
                <Sider
                  prefixCls={className}
                  isOpen={showDrawerSider}
                  loading={loadingSider}
                  data={siderData}
                  selectedKeys={siderSelectedKeys}
                  onChange={this.handleSiderSelectedKeysChange}
                />
              )}
              {has_sider && (
                <Button
                  className={`${className}-sider-trigger`}
                  icon={showDrawerSider ? 'angle-right' : 'angle-left'}
                  onClick={this.handleSiderTriggerClick}
                />
              )}
            </div>
          );
        }}
      </Transition>
    );
  }
}

const mapStateToProps = (state: any, ownProps: any) => {
  const account = state.account;
  const smProjectDetail = ownProps.projectDetail || state.smProjectDetail;

  let menus = ownProps.menus;
  if (!menus) {
    const menu = _.find(_.get(account, 'menus') || [], (menu: any) => {
      return menu.key === 'smWorkbench';
    });
    menus = _.get(menu, 'children') || [];
  }

  return {
    account,
    menus,
    ...smProjectDetail,
  };
};
const mapDispatchToProps = (
  dispatch: Dispatch<actions.ProjectDetailActions>,
  ownProps: any,
) => {
  return bindActionCreators(
    {
      loadDetail: ownProps.loadDetail || actions.loadDetail,
      clearDetail: ownProps.clearDetail || actions.clearDetail,
      toggleDrawerSiderShow:
        ownProps.toggleDrawerSiderShow || actions.toggleDrawerSiderShow,
      projectMove: ownProps.projectMove || projectMove,
      projectDelete: ownProps.projectDelete || projectDelete,
    },
    dispatch,
  );
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProjectDetailDrawer);
